var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconManageProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.992,
    height: 35.532,
    viewBox: "0 0 39.992 35.532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-manage-profile",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M29.514,43.063a15.1,15.1,0,0,0-29.4,0,3.993,3.993,0,0,0,.765,3.409A4.125,4.125,0,0,0,4.13,48.037H25.491a4.113,4.113,0,0,0,3.246-1.572,3.987,3.987,0,0,0,.777-3.4Z",
    transform: "translate(-0.012 -12.506)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M19.286,16.031A8.016,8.016,0,1,0,11.27,8.016a8.016,8.016,0,0,0,8.016,8.016Z",
    transform: "translate(-4.49 0)",
    fill: "#ffffff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2",
    transform: "translate(26.594 5.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "equalizer-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M3.522,3.729H2.694V.622a.622.622,0,1,0-1.243,0V3.729H.622a.622.622,0,0,0,0,1.243h2.9a.622.622,0,1,0,0-1.243Z",
    transform: "translate(0.602 0.602)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170_-_Outline",
    "data-name": "Path 170 - Outline",
    d: "M3.125,5.177H.224a1.224,1.224,0,1,1,0-2.448H.45V.224A1.224,1.224,0,1,1,2.9.224V2.729h.227a1.224,1.224,0,0,1,0,2.448ZM.224,3.934a.019.019,0,0,0,0,.039h2.9a.019.019,0,0,0,0-.039H1.694V.224a.019.019,0,0,0-.039,0v3.71Z",
    transform: "translate(1 1)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M7.622,28A.622.622,0,0,0,7,28.622v5.387a.622.622,0,1,0,1.243,0V28.622A.622.622,0,0,0,7.622,28Z",
    transform: "translate(-4.947 -21.596)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171_-_Outline",
    "data-name": "Path 171 - Outline",
    d: "M7.224,27a1.225,1.225,0,0,1,1.224,1.224v5.387a1.224,1.224,0,1,1-2.448,0V28.224A1.225,1.225,0,0,1,7.224,27Zm0,6.63a.019.019,0,0,0,.019-.019V28.224a.019.019,0,1,0-.039,0v5.387A.019.019,0,0,0,7.224,33.63Z",
    transform: "translate(-4.55 -21.199)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M42.372,3.729h-.829V.622a.622.622,0,1,0-1.243,0V3.729h-.829a.622.622,0,1,0,0,1.243h2.9a.622.622,0,0,0,0-1.243Z",
    transform: "translate(-30.198 0.602)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172_-_Outline",
    "data-name": "Path 172 - Outline",
    d: "M41.975,5.177h-2.9a1.224,1.224,0,0,1,0-2.448H39.3V.224a1.224,1.224,0,0,1,2.448,0V2.729h.227a1.224,1.224,0,0,1,0,2.448Zm-2.9-1.243a.019.019,0,1,0,0,.039h2.9a.019.019,0,1,0,0-.039H40.544V.224a.019.019,0,1,0-.039,0v3.71Z",
    transform: "translate(-29.801 1)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M46.472,27a.622.622,0,0,0-.622.622v5.594a.622.622,0,0,0,1.243,0V27.622A.622.622,0,0,0,46.472,27Z",
    transform: "translate(-35.748 -20.804)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173_-_Outline",
    "data-name": "Path 173 - Outline",
    d: "M46.074,26A1.225,1.225,0,0,1,47.3,27.224v5.594a1.224,1.224,0,1,1-2.448,0V27.224A1.225,1.225,0,0,1,46.074,26Zm0,6.837a.019.019,0,0,0,.019-.019V27.224a.019.019,0,1,0-.039,0v5.594A.019.019,0,0,0,46.074,32.837Z",
    transform: "translate(-35.35 -20.406)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M22.952,36h-2.9a.622.622,0,1,0,0,1.243h.829v3.108a.622.622,0,0,0,1.243,0V37.243h.829a.622.622,0,0,0,0-1.243Z",
    transform: "translate(-14.802 -27.939)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174_-_Outline",
    "data-name": "Path 174 - Outline",
    d: "M19.654,35h2.9a1.224,1.224,0,1,1,0,2.448h-.227v2.506a1.224,1.224,0,0,1-2.448,0V37.448h-.227a1.224,1.224,0,1,1,0-2.448Zm2.9,1.243a.019.019,0,1,0,0-.039h-2.9a.019.019,0,1,0,0,.039h1.431v3.71a.019.019,0,0,0,.039,0v-3.71Z",
    transform: "translate(-14.404 -27.541)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M27.052,6.837a.622.622,0,0,0,.622-.622V.622a.622.622,0,1,0-1.243,0V6.216A.622.622,0,0,0,27.052,6.837Z",
    transform: "translate(-20.352 0.602)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175_-_Outline",
    "data-name": "Path 175 - Outline",
    d: "M26.654,7.042A1.225,1.225,0,0,1,25.43,5.818V.224a1.224,1.224,0,1,1,2.448,0V5.818A1.225,1.225,0,0,1,26.654,7.042Zm0-6.837a.019.019,0,0,0-.019.019V5.818a.019.019,0,1,0,.039,0V.224A.019.019,0,0,0,26.654.2Z",
    transform: "translate(-19.954 1)",
    fill: "#ffffff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManageProfile);
export default __webpack_public_path__ + "static/media/icon-manage-profile.85c1fbaf77149190f9063c2c95f76b1c.svg";
export { ForwardRef as ReactComponent };